import { get, isEqual } from 'lodash';
import generateClientData from './generateClientData';
import getMilitaryEnumDisplayName from './getMilitaryEnumDisplayName';
function getCurrentStatus(militaryAffiliation, contact, enums) {
  if (isEqual(militaryAffiliation, 'military_member_or_veteran')) {
    return getMilitaryEnumDisplayName(get(contact.military, 'current_status'), enums, 'current_status');
  }
  return undefined;
}
export default function filterMilitaryInfo(contact, enums, isMilitaryFocused) {
  if (!isMilitaryFocused) {
    return [];
  }
  var militaryAffiliation = get(contact.military, 'affiliation');
  var currentStatus = getCurrentStatus(militaryAffiliation, contact, enums);
  return [generateClientData('military affiliation', getMilitaryEnumDisplayName(militaryAffiliation, enums, 'affiliation')), generateClientData('current status', currentStatus)];
}
//# sourceMappingURL=filterMilitaryInfo.js.map